document.addEventListener('DOMContentLoaded', function() {
  const carouselElements = document.querySelectorAll('[data-main-carousel]');
  carouselElements.forEach(function(carouselEl) {
    const section = carouselEl.closest('.featured-stages-carousel-section');
    const tabsNav = section.querySelector('[data-tabs-nav]');
    const tabs = tabsNav ? tabsNav.querySelectorAll('.tab-btn') : [];
    const prevBtn = section.querySelector('.carousel-prev');
    const nextBtn = section.querySelector('.carousel-next');
    
    const flkty = new Flickity(carouselEl, {
      accessibility: true,
      adaptiveHeight: false,
      autoPlay: false,
      cellAlign: 'center',
      cellSelector: undefined,
      contain: false,
      draggable: '>1',
      dragThreshold: 3,
      freeScroll: false,
      friction: 0.2,
      groupCells: false,
      initialIndex: 1,
      lazyLoad: false,
      percentPosition: true,
      prevNextButtons: false,
      pageDots: true,
      resize: true,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: false,
      wrapAround: false
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        flkty.previous();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        flkty.next();
      });
    }

    function updateButtonVisibility() {
      const currentIndex = flkty.selectedIndex;
      const slideCount = flkty.slides.length;
      if (currentIndex === 0) {
        if (prevBtn) prevBtn.style.display = 'none';
      } else {
        if (prevBtn) prevBtn.style.display = 'flex';
      }

      if (currentIndex === slideCount - 1) {
        if (nextBtn) nextBtn.style.display = 'none';
      } else {
        if (nextBtn) nextBtn.style.display = 'flex';
      }
    }


    updateButtonVisibility();
    flkty.on('change', function(index) {
      updateButtonVisibility();
      if (tabs.length > 0) {
        tabs.forEach(function(tab) {
          tab.classList.remove('active');
        });
        
        if (tabs[index]) {
          tabs[index].classList.add('active');
        }
      }
    });

    if (tabs.length > 0) {
      tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
          const slideIndex = parseInt(this.getAttribute('data-slide'));
          flkty.select(slideIndex);
        });
      });
    }


    function handleResize() {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        flkty.resize();
      }
      updateButtonVisibility();
    }
    handleResize();
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 250);
    });
  });
});